// extracted by mini-css-extract-plugin
export default {"menu":"CustomizeMenu_menu__Gn0J9","submenu":"CustomizeMenu_submenu__HnxU6","button":"CustomizeMenu_button__gBqvg","active":"CustomizeMenu_active__Q-m8a"};